import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux';

import RenderProfilePicture from '../../../../_helpers/profile-picture'

import { service } from '../../../../_services/conversation.service';
import { AsyncPaginate } from "react-select-async-paginate";
import '../style.css'


class ParticipantSearch extends Component {
  constructor(props) {
    super(props)

    this.axiosInstance = axios.create()
    this.handleChange = this.handleChange.bind(this)
    this.handleLoadOptions = this.handleLoadOptions.bind(this)
  }

  handleChange(selected) {
    let participant = ''

    if (selected) {
      participant = { value: selected.userId, label: `${selected.firstName} ${selected.lastName}` }
    }
    this.props.handleSelected(participant, selected)
  }

  async handleLoadOptions(term, callback, { page }) {
    const name = term.split(" ")

    const searchParams = {
      firstName: name[0] || '',
      lastName: name.length > 1 ? name[1] : '',
      page: page || ''
    }
    const response = await service.getParticipants(searchParams)
      .then(response => {
        if (this.props.removeCurrentUser) {
          return {
            ...response,
            collection: {
              data: response.collection.data.filter((user) => {
                return user.userId !== this.props.currentUser.UserId
              })
            }
          }
        }

        return response;
      })

    const responseData = await response;
    
    return {
      options: responseData.collection.data,
      hasMore: responseData.total > responseData.lastIndex,
      additional: {
        page: responseData.nextPage
      }
    }
  }

  render() {
    const CustomOption = ({ innerProps, isDisabled, ...props }) => {
      return <div {...innerProps} className='custom__option'>
        <div className='row p-3'>
          <div className='col-auto'>
            <RenderProfilePicture image={props.data.profile} circle cached={false} width={40} height={40} className='m-auto' />
          </div>
          <div className='col-auto'>
            <div>
              {`${props.data.firstName} ${props.data.lastName}`}
            </div>
            <div style={{ fontSize: 'small' }} className="font-weight-light">
              {props.data.userType}
            </div>
          </div>
        </div>
      </div>
    }

    return (
      <AsyncPaginate
        isClearable
        key={JSON.stringify(this.props.participant)}
        value={this.props.participant}
        onChange={this.handleChange}
        loadOptions={this.handleLoadOptions}
        className={this.props.invalid ? 'is-invalid' : ''}
        placeholder={this.props.placeholder}
        additional={{
          page: 1,
        }}
        styles={{
          menu: (styles) => {
            return { ...styles, zIndex: 99 }
          }
        }}
        components={{ Option: CustomOption }}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser
  }
}

export default connect(mapStateToProps)(ParticipantSearch)
